/**
 * Buckets
 */
export var RESEARCHERS = 'researchers';
export var BROWSERS = 'browsers';
export var BUYERS = 'buyers'; // Order matters

export var BUCKETS = [RESEARCHERS, BROWSERS, BUYERS];